export class LocalStorageHelper {
  static getItem = (key: string) => {
    try {
      const serializedItem = window.localStorage.getItem(key);
      return serializedItem ? JSON.parse(serializedItem) : null;
    } catch (err) {
      return null;
    }
  };

  static setItem = (key: string, value: any) => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (err) {
      return null;
    }
  };
}
